import React from "react";
import firebase from "firebase/compat/app";
import { ServiceCallerProps } from "../../Admin/composition";
import IRequest from "../../types/services/IRequest";

export type DisplayState = "normal" | "executing" | "success" | "error";

export interface RequestComponentProps extends ServiceCallerProps {
  isOpen: boolean;
  toggle: () => void;
  firebase: firebase.app.App;
  userId: string;
  request?: IRequest;
}

export interface RequestComponentState {
  displayState: DisplayState;
}

export class RequestComponent<
  P extends RequestComponentProps,
  S extends RequestComponentState
> extends React.Component<P, S> {
  constructor(props: P) {
    super(props);
    this.state = {
      displayState: "normal" as DisplayState,
    } as S;
  }

  submitRequest(request: IRequest, isUpdate: boolean) {
    this.setState(
      {
        displayState: "executing",
      },
      () => {
        const ref = this.props.firebase
          .database()
          .ref()
          .child(this.props.currentCharity.id)
          .child("requests");
        if (isUpdate) {
          ref
            .child(this.props.request.id)
            .set(request)
            .then(
              () => {
                this.timeoutMessage("success", true);
              },
              () => {
                this.timeoutMessage("error", false);
              }
            );
        } else {
          ref
            .push(request)
            .then()
            .then(
              () => {
                this.timeoutMessage("success", true);
              },
              () => {
                this.timeoutMessage("error", false);
              }
            );
        }
      }
    );
  }

  timeoutMessage(displayState: DisplayState, closeModal: boolean) {
    this.setState(
      {
        displayState: displayState,
      },
      () => {
        setTimeout(() => {
          if (closeModal) {
            this.props.toggle();
          } else {
            this.setState({
              displayState: "normal",
            });
          }
        }, 2000);
      }
    );
  }
}
